<template>
    <div class="modal fade share-bet-modal" id="qrShareModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered information-modal-wrapper">
            <div class="modal-content">
                <button type="button" class="cross_btn_top" data-bs-dismiss="modal" aria-label="Close">&#10006;</button>
                <div class="modal-body">
                    <section class="sub-header-wrapper">
                        <div class="qrPreview-image login-by-social-icon">
                            <div class="footer-social-bx shared_social_img">
                                <div class="f-social-icon">
                                    <a :href="`https://telegram.me/share/url?url=${qrCode}`" target="_blank">
                                        <img src="@/assets/images/telegram-icon.svg" alt="telegram" loading="lazy" />
                                    </a>
                                </div>
                                <div class="f-social-icon">
                                    <a :href="`https://api.whatsapp.com/send?text=${encodeURIComponent(qrCode)}`" target="_blank">
                                        <img src="@/assets/images/whatsapp-social.svg" alt="whatsapp" loading="lazy" />
                                    </a>
                                </div>
                                <div class="f-social-icon">
                                    <a :href="`https://www.instagram.com/create/story?media=${qrCode}`" target="_blank">
                                        <img src="@/assets/images/instagram-icon.svg" alt="instagram-icon" loading="lazy" />
                                    </a>
                                </div>
                                <div class="f-social-icon">
                                    <a :href="`https://www.facebook.com/sharer/sharer.php?u=${qrCode}`" target="_blank">
                                        <img loading="lazy" src="@/assets/images/facebook-icon.svg" alt="facebook-icon" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'qrCodeShareModal',
    props: ['qrCode']
}
</script>